import { useState} from "react";
import CustomFileInput from "../../../components/customFileInput";
import Input from "../../../components/input";
import Select from "../../../components/select";
import close from "../../../assets/icons/close.svg";
import { useBankList } from "../../reuseableEffects";


const VerifyCampaign = ({
  bankName, selectedBank, onBankChange, onBankBlur, onBankError,
  accountNumberName, accountNumberValue, accountNumberOnChange, accountNumberOnBlur, accountNumberOnError,
  bvnName, bvnValue, bvnOnChange, bvnOnBlur, bvnOnError,
  onC07FileSelect, onCacFileSelect, onReferenceLetterSelect, onBoardResolutionSelect,
  hideC07, hideCAC, hideBoardResolution
}) => {
  
  const [showModal, setShowModal] = useState(false);

  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const handleC07FileChange = (files) => {
    const selectedFile = files ? files[0] : null;
    if (onC07FileSelect) {
      onC07FileSelect(selectedFile);
    }
  };

  const handleCacFileChange = (files) => {
    const selectedFile = files ? files[0] : null;
    if (onCacFileSelect) {
      onCacFileSelect(selectedFile);
    }
  };

  const handleReferenceLetterChange = (files) => {
    const selectedFile = files ? files[0] : null;
    if (onReferenceLetterSelect) {
      onReferenceLetterSelect(selectedFile);
    }
  };

  const handleBoardResolutionChange = (files) => {
    const selectedFile = files ? files[0] : null;
    if (onBoardResolutionSelect) {
      onBoardResolutionSelect(selectedFile);
    }
  };

  const banks = useBankList();
  const sortedBanks = [...banks].sort((a, b) => a.name.localeCompare(b.name));

      
    return (
      <div>
        <div className="grid mt-4 mb-8">
          <span className="font-semibold">Step 4 of 5</span>
          <span className="text-secondary text-sm">Campaign verification</span>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <Select
              label={"Bank name"}
              placeholder={"Select a bank"}
              name={bankName}
              value={selectedBank}
              onChange={onBankChange}
              onBlur={onBankBlur}
              onError={onBankError}
              options={sortedBanks}
            />
          <Input
            label={"Account number"}
            type={"number"}
            name={accountNumberName}
            value={accountNumberValue}
            onChange={accountNumberOnChange}
            onBlur={accountNumberOnBlur}
            onError={accountNumberOnError}
          />
          <Input
            label={"BVN"}
            type={"number"}
            name={bvnName}
            value={bvnValue}
            onChange={bvnOnChange}
            onBlur={bvnOnBlur}
            onError={bvnOnError}
          />
        </div>
        <div className=" text-secondary text-sm my-5">
          * Before your campaign is approved, it has to go through a
          verification process. Please provide documents that can confirm that
          your campaign is indeed a valid case. <br />
          <span
            onClick={openModal}
            className="underline text-brandGreen cursor-pointer"
          >
            Verification documents guide.
          </span>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 w-full  gap-4 mb-8">
          <div className={`${hideC07}`}>
            <CustomFileInput
              fileToUpload={"doc"}
              onFileChange={handleC07FileChange}
            />
          </div>
          <div className={`${hideCAC}`}>
            <CustomFileInput
              fileToUpload={"doc"}
              onFileChange={handleCacFileChange}
            />
          </div>
            <CustomFileInput
              fileToUpload={"doc"}
              onFileChange={handleReferenceLetterChange}
            />
          <div className={`${hideBoardResolution}`}>
            <CustomFileInput
              fileToUpload={"doc"}
              onFileChange={handleBoardResolutionChange}
            />
          </div>
          
        </div>
        {showModal && 
          (<div className="fixed top-0 w-full h-screen bg-black/60 flex justify-center items-center px-4 z-50 left-0">
            <div className="bg-white max-h-[80%] md:max-h-[90%] overflow-y-auto w-full md:w-[50%] rounded">
              <div className="flex justify-between items-center px-6 pb-4 pt-6">
                <span className="font-semibold">Verification documents guide</span>
                <span onClick={closeModal} className="cursor-pointer"><img src={close} alt="" className="h-4" /></span>
              </div>
              <div className="px-6 pt-4 pb-8 text-sm">
                <p>To ensure credibility and security, we require certain documents to verify your identity and the legitimacy of your campaign. </p>
                <ul className="mt-4 grid gap-6">
                  <li className="list-decimal list-inside">
                    Government-Issued ID
                    <ul className="ps-7 list-disc">
                      <li>Accepted Forms: Passport, Driver's License, National ID Card</li>
                      <li>Requirements: Must be valid and include your full name, photo, and date of birth.</li>
                    </ul>
                  </li>
                  <li className="list-decimal list-inside">
                    Proof of address
                    <ul className="ps-7 list-disc">
                      <li>Accepted Forms: Utility Bill, Bank Statement, Rental Agreement</li>
                      <li>Requirements: Must be recent (within the last three months) and include your name and address.</li>
                    </ul>
                  </li>
                  <li className="list-decimal list-inside">
                    Campaign-Specific Documents
                    <ul className="ps-7 list-disc">
                      <li>For Individuals: Medical Reports, School Admission Letters, or any document supporting your cause.</li>
                      <li>For Corporate Organizations: Business Registration Certificate, Tax Identification Number, or Corporate Bank Statement.</li>
                      <li>For NGOs: Certificate of Incorporation, NGO Registration, or any relevant governmental documentation.</li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>)
        }
      </div>
    );
}

export default VerifyCampaign;